import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles({
  box: {
    background: '#F9F9F9',
    position: 'relative'
  }
})

function StyledCard({ children, ...props }) {

  const styles = useStyles()

  return (
    <Box my={2}>
      <Card variant="outlined">
        <Box p={2} {...props} className={styles.box}>{children}</Box>
      </Card>
    </Box>
    );
}

export default StyledCard;